import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventEmitterService } from '../../Services/Common/event-emitter.service';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../../Components/table/table.component';
import { FilterPopoverComponent } from '../../Components/filter-popover/filter-popover.component';
import { RouterModule } from '@angular/router';
import { DataUnavailableComponent } from '../common/data-unavailable/data-unavailable.component';
import { ShimmerLoaderComponent } from "../../Components/shimmer-loader/shimmer-loader.component";
import { ApiService } from '../../Services/api';
import { AlertService } from '../../Services/notifications/alert.service';
import { LoggerService } from '../../Services/logger';

@Component({
    selector: 'app-otb-community',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule,
        TableComponent,
        RouterModule,
        FilterPopoverComponent,
        DataUnavailableComponent,
        ShimmerLoaderComponent
    ],
    templateUrl: './otb-community.component.html',
    styleUrls: ['./otb-community.component.scss']
})
export class OtbCommunityComponent implements OnInit, OnChanges {
    @Input() data: any;
    isLoading: boolean = true;
    activeTab: string = 'Community Feed';
    searchQuery: string = '';
    showFilterPopover: boolean = false;
    filterOptions: string[] = ['Approved', 'Declined', 'Under Review'];
    selectedFilters: Set<string> = new Set();
    noDataFound: boolean = false;

    @ViewChild(TableComponent) tableComponent!: TableComponent;
    @ViewChild('activitySearch') activitySearchRef?: ElementRef<HTMLInputElement>;

    constructor(
        private bus: EventEmitterService,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private apiService: ApiService,
        private alertService: AlertService,
        private logger: LoggerService
    ) { }

    ngOnInit(): void {
        this.isLoading = true;
        // this.logger.info('OtbCommunityComponent data (initial)', this.data, 'otb-community.component.ts');

        if (!this.data) {
            this.isLoading = true;
        } else {
            //   setTimeout(()=>{ 
        //   this.isLoading = false;
            //   this.cdr.markForCheck()
            // },10000)
            if (this.data?.tabs?.length) {
                this.activeTab = this.data.tabs[0];
            }
        }

        const handleApiResponse = (resp: any) => {
            try {
                this.isLoading = true;
                if (resp && resp.data) {
                    const newData = {
                        ...(this.data || {}),
                        myActivity: {
                            ...(this.data?.myActivity || {}),
                            tableHeadings: resp.data.myActivity?.tableHeadings || [],
                            tableData: resp.data.myActivity?.tableData || [],
                            tableUrls: resp.data.myActivity?.tableUrls || []
                        },
                        questions: resp.data.community || []
                    };
                    this.isLoading=false;
                    this.noDataFound=false;
                    this.data = newData;
                    this.logger.info('OtbCommunityComponent data (from API)', this.data, 'otb-community.component.ts');
                }
            } catch (e) {
                // this.logger.warn('Failed to parse community API response', e, 'otb-community.component.ts');
                this.noDataFound = true;
                this.isLoading=false;
            }

            if (this.data?.tabs?.length) {
                this.activeTab = this.data.tabs[0];
            }
            //   setTimeout(()=>{
            this.isLoading = false;
            //   this.cdr.markForCheck()
            // },10000)
            try { this.cdr.detectChanges(); } catch (_) { /* ignore */ }
        };

        this.apiService.get(`/community`).subscribe({
            next: (resp) => handleApiResponse(resp),
            error: (err) => {
                this.isLoading = false;
                this.noDataFound=true;
                this.logger.error('Failed to load community data', err, 'otb-community.component.ts');
                this.alertService.show('Unable to load community feed.', { type: 'error', duration: 3000 });
                this.cdr.markForCheck();
            }
        });
    }

    trackById(index: number, item: any) {
        return item?.id ?? index;
    }

    ngOnChanges(changes: SimpleChanges) {
        // this.logger.debug('OtbCommunityComponent ngOnChanges', changes, 'otb-community.component.ts');
        if (changes['data'] && this.data) {
            if (this.data?.tabs?.length) {
                this.activeTab = this.data.tabs[0];
            }
        }
    }

    setActiveTab(tab: string) {
        this.activeTab = tab;
        this.searchQuery = '';
    }

    navigate() {
        this.router.navigate(['/community/ask']);
    }

    goToQuestions(category?: string) {
        try {
            if (category) {
                this.router.navigate(['/community/questions'], { queryParams: { category } });
            } else {
                this.router.navigate(['/community/questions']);
            }
        } catch (e) {
            this.logger.warn('Navigation to community questions failed', e, 'otb-community.component.ts');
        }
    }

    onSearch(query: string) {
        if (this.activeTab === 'My Activity' && this.tableComponent) {
            this.tableComponent.searchText = query;
            this.tableComponent.onFilterChange();
        }
    }

    togglePopover(event: MouseEvent) {
        event.stopPropagation();
        this.showFilterPopover = !this.showFilterPopover;
    }

    applyFilter() {
        this.showFilterPopover = false;
        if (this.activeTab === 'My Activity' && this.tableComponent) {
            this.tableComponent.selectedStatuses = new Set(this.selectedFilters);
            this.tableComponent.applyStatusFilter();
        }
    }

    resetFilter() {
        this.selectedFilters.clear();
        this.showFilterPopover = false;
        if (this.activeTab === 'My Activity' && this.tableComponent) {
            this.tableComponent.resetStatusFilter();
        }
    }

    clearSearch() {
        this.searchQuery = '';
        if (this.activeTab === 'My Activity' && this.tableComponent && typeof this.tableComponent.clearText === 'function') {
            this.tableComponent.clearText();
        } else {
            this.onSearch('');
        }
        try {
            if (this.activitySearchRef && this.activitySearchRef.nativeElement) {
                this.activitySearchRef.nativeElement.blur();
            }
        } catch (e) {
            // ignore
        }
    }

    onTableFiltersCleared(): void {
        try {
            this.searchQuery = '';
            this.cdr.detectChanges();
            if (this.activitySearchRef && this.activitySearchRef.nativeElement) {
                try { this.activitySearchRef.nativeElement.value = ''; this.activitySearchRef.nativeElement.blur(); } catch (e) { /* ignore */ }
            }
        } catch (err) {
            this.logger.warn('Failed to handle filtersCleared event', err, 'otb-community.component.ts');
        }
    }


}
